import React from "react";
import { createRoot } from "react-dom/client";
import InvoiceChargeTypeIsland from "./InvoiceChargeTypeIsland";

const mountNode = document.getElementById("invoice-charge-type-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<InvoiceChargeTypeIsland config={config} />);
  }
}
